import axios from 'axios';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 基础URL，使用环境变量
  timeout: 15000, // 请求超时时间
  withCredentials: true // 跨域请求时发送cookies
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 设置 Accept-Language header
    const locale = localStorage.getItem('locale') || 'cn';
    config.headers['Accept-Language'] = locale;
    // 调试用: 打印实际请求URL
    console.log('发送请求到:', config.baseURL + config.url);
    
    // 可以在这里添加token等认证信息
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers['Authorization'] = 'Bearer ' + token;
    // }
    return config;
  },
  error => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    
    // 为了调试，先直接返回完整响应数据
    console.log('API响应数据：', res);
    
    // 根据后端API约定的状态码判断请求是否成功
    // 返回结构是 { code: xxx, msg: 'xxx', rows: xxx, total: xxx }
    if (res.code !== 200) {
      // 使用控制台输出替代Element UI的消息提示
      console.error('请求失败:', res.msg || '未知错误');
      
      return Promise.reject(new Error(res.msg || '未知错误'));
    } else {
      return res; // 返回完整响应，包含rows和total
    }
  },
  error => {
    console.error('Response error:', error);
    
    // 处理HTTP错误状态
    let message = '请求失败';
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = '请求错误';
          break;
        case 401:
          message = '未授权，请登录';
          break;
        case 403:
          message = '拒绝访问';
          break;
        case 404:
          message = '请求地址不存在';
          break;
        case 500:
          message = '服务器内部错误';
          break;
        default:
          message = `连接错误${error.response.status}`;
      }
    } else {
      message = '网络连接异常';
    }
    
    // 使用控制台输出替代Element UI的消息提示
    console.error(message);
    
    return Promise.reject(error);
  }
);

export default service; 